<app-nav titulo="Monedas" descripcion="Aquí podrá ver, editar y borrar todos los datos sobre monedas registrados en la plataforma">

    <div class="currency">

        <!-- <div class="form-buttons">
            <button mat-raised-button class="garantor-button add-button" color="primary">
                <mat-icon matPrefix class="add-button-icon">add</mat-icon>
                <span class="add-button-label">Nueva moneda</span>
            </button>
        </div> -->
        <!-- <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter> -->
        <app-data-table
            [rows]="currencies"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
        ></app-data-table>
    </div>
</app-nav>

<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Editar moneda" class="edit-row-button">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Eliminar" class="view-more-row-button" >
            <mat-icon color="primary">delete</mat-icon>
        </button>
    </div>
</ng-template>
